import React, { memo, useMemo } from "react";
import Icon from "../../../../components/Icon";
import { MAIN_EXCLUSIONS } from "../../constants/main-exclusions";

const ExclusionsQuestions = () => {
    const mainExlusions = useMemo(() => MAIN_EXCLUSIONS, []);
    return (
        <div className="landing-who-can-hire__item">
            <div className="landing-who-can-hire__item-footer-title">
                ¿Cuáles son las principales <br />
                exclusiones?
            </div>
            <div className="landing-who-can-hire__item-footer">
                {mainExlusions.map(({ id, icon, content, image }) => (
                    <div key={id} className="landing-who-can-hire__item-footer-card">
                        <div className="landing-who-can-hire__item-icon">
                            <Icon name={icon} image={image} />
                        </div>
                        <div>{content}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default memo(ExclusionsQuestions);
